import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { pageForPath, structuredDataFor, SITE_URL, SITE_NAME, SOCIAL_IMAGE } from './pages';

export default function Seo() {
  const { pathname } = useLocation();
  const page = pageForPath(pathname);
  const canonical = SITE_URL + encodeURI(page.path);
  return <Helmet htmlAttributes={{ lang: 'sv' }}>
    <title>{page.title}</title>
    <meta name="description" content={page.description} />
    <meta name="robots" content={page.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large'} />
    {!page.noindex && <link rel="canonical" href={canonical} />}
    <meta property="og:locale" content="sv_SE" />
    <meta property="og:site_name" content={SITE_NAME} />
    <meta property="og:type" content={page.kind === 'article' ? 'article' : 'website'} />
    <meta property="og:title" content={page.title} />
    <meta property="og:description" content={page.description} />
    <meta property="og:url" content={canonical} />
    <meta property="og:image" content={SOCIAL_IMAGE} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:image:alt" content="THAS Ekonomi och Redovisning – bokföring och redovisning i Stockholm" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={page.title} />
    <meta name="twitter:description" content={page.description} />
    <meta name="twitter:image" content={SOCIAL_IMAGE} />
    {!page.noindex && <script type="application/ld+json">{JSON.stringify(structuredDataFor(page)).replace(/</g, '\\u003c')}</script>}
  </Helmet>;
}
